import { Icon } from "@iconify/react";
import { useDispatch } from "react-redux";
import {
  openAreaConfirmToggle,
  openAreaFormModal,
  openAreaViewModal,
} from "../../store/reducers/fortalezas/fortalezas.reducer";
import { getAreaDesarrolloByIdThunk } from "../../store/reducers/fortalezas/fortalezas.thunks";

const AreaActions = ({ area }) => {
  const dispatch = useDispatch();

  const handleEdit = async () => {
    await dispatch(getAreaDesarrolloByIdThunk(area.id));
    dispatch(openAreaFormModal());
  };

  const handleToggle = () => {
    dispatch(
      openAreaConfirmToggle({
        id: area.id,
      })
    );
  };

  const handleView = () => {
    dispatch(openAreaViewModal());
    dispatch(getAreaDesarrolloByIdThunk(area.id));
  };

  const itemClass =
    "dropdown-item px-16 py-8 rounded d-flex align-items-center gap-2 text-secondary-light bg-hover-neutral-200 text-hover-neutral-900";

  return (
    <div className="dropdown text-center">
      <button
        type="button"
        className="btn btn-sm"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <Icon
          icon="ph:dots-three-outline-vertical-fill"
          width="20"
          className="text-neutral-700"
        />
      </button>

      <ul className="dropdown-menu p-12 border bg-base shadow">
        <li>
          <button className={itemClass} onClick={handleView}>
            <Icon icon="mdi:eye-outline" width="18" />
            <span>Ver</span>
          </button>
        </li>

        <li>
          <button className={itemClass} onClick={handleEdit}>
            <Icon icon="mdi:pencil-outline" width="18" />
            <span>Editar</span>
          </button>
        </li>

        <li>
          <button
            className={`${itemClass} ${area.is_active ? "text-danger" : "text-success"}`}
            onClick={handleToggle}
          >
            <Icon
              icon={
                area.is_active
                  ? "mdi:toggle-switch-off-outline"
                  : "mdi:toggle-switch-outline"
              }
              width="18"
            />
            <span>{area.is_active ? "Desactivar" : "Activar"}</span>
          </button>
        </li>
      </ul>
    </div>
  );
};

export default AreaActions;
